var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYesbookmarkBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25.75V2.90776C0 2.15044 0.253629 1.51815 0.760887 1.01089C1.26815 0.503629 1.90044 0.25 2.65776 0.25H17.0842C17.8415 0.25 18.4738 0.503629 18.981 1.01089C19.4883 1.51815 19.7419 2.15044 19.7419 2.90776V25.75L9.87097 21.5104L0 25.75Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesbookmarkBlack);
export default __webpack_public_path__ + "static/media/yesbookmark_black.d09035477f5dde8bf1202a65956033cc.svg";
export { ForwardRef as ReactComponent };